import { render, staticRenderFns } from "./product-tabs.vue?vue&type=template&id=bef98a7e&scoped=true&"
import script from "./product-tabs.vue?vue&type=script&lang=js&"
export * from "./product-tabs.vue?vue&type=script&lang=js&"
import style0 from "./product-tabs.vue?vue&type=style&index=0&id=bef98a7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef98a7e",
  null
  
)

export default component.exports